import { JSX } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../../componentes/topBar";
import { ReactComponent as IconLogo } from "../../assets/logosSvg/logoEasyBI.svg";
import { useTheme } from "@mui/material";
import { TemplateProvider } from "../../context/templateContext";

function LayoutPublic(): JSX.Element {
  const theme = useTheme();
  return (
    <>
      <TemplateProvider>
        <TopBar
          isPublic={true}
          iconLogo={<IconLogo />}
          link={"/login"}
          backgroundColor={theme.palette.background.paper}
          ocultar={true}
        />
      </TemplateProvider>
      <Outlet />
    </>
  );
}

export default LayoutPublic;
